<template>
  <main >

    <!-- NAV -->
    <nav
      :class="[
        'fixed top-0 left-0 right-0 z-50 transition-all duration-300',
        isScrolled
          ? 'bg-white border-b shadow-sm'
          : 'bg-transparent'
      ]"
    >

      <div class="max-w-7xl mx-auto px-6">
        <div class="flex items-center justify-between h-20">
          <h1
            :class="[
              'font-serif text-2xl transition-colors',
              isScrolled ? 'text-gray-900' : 'text-white'
            ]"
          >
            River Modern
          </h1>

          <div class="hidden md:flex items-center gap-8">
            <button
                v-for="l in navLinks"
                :key="l.id"
                @click="scrollTo(l.id)"
                :class="[
                  'uppercase text-sm transition-colors',
                  isScrolled
                    ? 'text-gray-700 hover:text-black'
                    : 'text-white hover:text-gray-200'
                ]"
              >
                {{ l.label }}
              </button>


            <button
              @click="scrollTo('contact')"
              :class="[
              ' border border-white px-3 py-1 text-white tracking-widesttransition-all duration-500 ease-out hover:bg-white hover:!text-black hover:-translate-y-0.5 hover:shadow-md',
                isScrolled
                  ? 'border-gray-900 text-gray-900'
                  : 'border-white text-white'
              ]"
            >
              Register
            </button>

          </div>
        </div>
      </div>
    </nav>

    <!-- HERO -->
    <section class="relative h-screen pt-20 flex items-center justify-center">
      <img :src="heroImage" class="absolute inset-0 w-full h-full object-cover" />
      <div class="absolute inset-0 bg-black/50"></div>

      <div class="relative text-center px-6">
        <p class="tracking-[0.3em] uppercase mb-4 text-sm text-white">
          ONE HOME, BOUNDLESS POSSIBILITIES
        </p>
        <h2 class="text-5xl md:text-7xl font-serif mb-6 text-white">
          River Modern
        </h2>
        
        <p class="text-lg mb-10 text-white max-w-2xl mx-auto leading-relaxed">
          Luxury living at River Valley by GuocoLand.<br />
          Where residential comfort, vibrant retail and connected community come together.
        </p>
                <!-- PREVIEW / BOOKING -->
            <!-- PREVIEW / BOOKING -->
        <div class="flex flex-col sm:flex-row justify-center gap-6 mb-10">

          <div class="bg-black/40 px-6 py-4 backdrop-blur-sm border border-white/10">
            <p class="text-xs tracking-widest uppercase text-white/70 mb-1">
              Target Preview
            </p>
            <p class="font-serif text-lg text-white">
              {{ launch.preview }}
            </p>
          </div>

          <div class="bg-black/40 px-6 py-4 backdrop-blur-sm border border-white/10">
            <p class="text-xs tracking-widest uppercase text-white/70 mb-1">
              Target Booking
            </p>
            <p class="font-serif text-lg text-white">
              {{ launch.booking }}
            </p>
          </div>
          <div class="bg-black/40 px-6 py-4 backdrop-blur-sm border border-white/10">
            <p class="text-xs tracking-widest uppercase text-white/70 mb-1">
              Expected TOP
            </p>
            <p class="font-serif text-lg text-white">
              2030
            </p>
          </div>

        </div>


        <button
          @click="scrollTo('contact')"
          class="
            border border-white px-8 py-3 text-white tracking-widest
            transition-all duration-500 ease-out
            hover:bg-white hover:!text-black
            hover:-translate-y-0.5 hover:shadow-md
          "
        >
          Register Interest
        </button>

      </div>
    </section>
    <!-- PROJECT DETAILS -->
    <section id="overview" class="py-24 bg-[#faf9f7]">
      <div class="max-w-7xl mx-auto px-6">

        <!-- HEADER -->
        <div class="text-center mb-16">
          <p class="text-xs tracking-[0.25em] uppercase text-amber-600 mb-4">
            Overview
          </p>
          <h2 class="text-4xl md:text-5xl font-serif text-gray-900 mb-6">
            Project Details
          </h2>
          <div class="w-16 h-px bg-amber-400 mx-auto"></div>
        </div>

        <!-- GRID -->
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">

          <!-- CARD -->
          <div class="border border-gray-200 bg-white/60 p-8 flex gap-5">
            <div class="w-12 h-12 flex items-center justify-center bg-[#f3efe8]">
              <Building2 class="w-5 h-5 text-amber-600" />
            </div>
            <div>
              <p class="text-xs uppercase tracking-widest text-gray-500 mb-2">
                Project Name
              </p>
              <p class="text-md font-serif text-gray-900">
                River Modern
              </p>
            </div>
          </div>

          <div class="border border-gray-200 bg-white/60 p-8 flex gap-5">
            <div class="w-12 h-12 flex items-center justify-center bg-[#f3efe8]">
              <Landmark class="w-5 h-5 text-amber-600" />
            </div>
            <div>
              <p class="text-xs uppercase tracking-widest text-gray-500 mb-2">
                Developer
              </p>
              <p class="text-md font-serif text-gray-900">
                GuocoLand
              </p>
            </div>
          </div>

          <div class="border border-gray-200 bg-white/60 p-8 flex gap-5">
            <div class="w-12 h-12 flex items-center justify-center bg-[#f3efe8]">
              <MapPin class="w-5 h-5 text-amber-600" />
            </div>
            <div>
              <p class="text-xs uppercase tracking-widest text-gray-500 mb-2">
                Location
              </p>
              <p class="text-md font-serif text-gray-900">
                River Valley Green (District 9)
              </p>
            </div>
          </div>

          <div class="border border-gray-200 bg-white/60 p-8 flex gap-5">
            <div class="w-12 h-12 flex items-center justify-center bg-[#f3efe8]">
              <Home class="w-5 h-5 text-amber-600" />
            </div>
            <div>
              <p class="text-xs uppercase tracking-widest text-gray-500 mb-2">
                Property Type
              </p>
              <p class="text-md font-serif text-gray-900">
                Private Condominium<br/>
                
              </p>
            </div>
          </div>
          <div class="border border-gray-200 bg-white/60 p-8 flex gap-5">
            <div class="w-12 h-12 flex items-center justify-center bg-[#f3efe8]">
              <CircleParking class="w-5 h-5 text-amber-600" />
            </div>
            <div>
              <p class="text-xs uppercase tracking-widest text-gray-500 mb-2">
                Carpark Lots
              </p>
              <p class="text-md font-serif text-gray-900">
                70% Carparks Lots
              </p>
            </div>
          </div>
          <div class="border border-gray-200 bg-white/60 p-8 flex gap-5">
            <div class="w-12 h-12 flex items-center justify-center bg-[#f3efe8]">
              <DoorOpen class="w-5 h-5 text-amber-600" />
            </div>
            <div>
              <p class="text-xs uppercase tracking-widest text-gray-500 mb-2">
                Number Of Units
              </p>
              <p class="text-md font-serif text-gray-900">
                455 Units
              </p>
            </div>
          </div>
          <div class="border border-gray-200 bg-white/60 p-8 flex gap-5">
            <div class="w-12 h-12 flex items-center justify-center bg-[#f3efe8]">
              <FileText class="w-5 h-5 text-amber-600" />
            </div>
            <div>
              <p class="text-xs uppercase tracking-widest text-gray-500 mb-2">
                Tenure
              </p>
              <p class="text-md font-serif text-gray-900">
                99-Year Leasehold <br/>Commencing From 13 Feb 2025
              </p>
            </div>
          </div>
          <div class="border border-gray-200 bg-white/60 p-8 flex gap-5">
            <div class="w-12 h-12 flex items-center justify-center bg-[#f3efe8]">
              <LandPlot class="w-5 h-5 text-amber-600" />
            </div>
            <div>
              <p class="text-xs uppercase tracking-widest text-gray-500 mb-2">
                Site Area & Plot Ratio
              </p>
              <p class="text-md font-serif text-gray-900">
                11,736sqm/123,325sqft <br/>Plot Ratio 3.5
              </p>
            </div>
          </div>
          <div class="border border-gray-200 bg-white/60 p-8 flex gap-5">
            <div class="w-12 h-12 flex items-center justify-center bg-[#f3efe8]">
              <Info class="w-5 h-5 text-amber-600" />
            </div>
            <div>
              <p class="text-xs uppercase tracking-widest text-gray-500 mb-2">
                Description
              </p>
              <p class="text-md font-serif text-gray-900">
                2 Towers 36-Storey <br/>High Rise Residential <br/>With 1st Storey Commercial
              </p>
            </div>
          </div>

          

        </div>
      </div>
    </section>


    <!-- DEVELOPER -->
    <section id="developer" class="py-24 bg-[#f6f2ea]">
  <div class="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-16 items-start">

    <!-- LEFT CONTENT -->
    <div>
      <p class="text-xs tracking-[0.25em] uppercase text-amber-600 mb-4">
        The Developer
      </p>

      <h2 class="text-4xl md:text-5xl font-serif text-gray-900 mb-6">
        GuocoLand
      </h2>

      <div class="w-12 h-px bg-amber-400 mb-8"></div>

      <div class="space-y-6 text-gray-700 leading-relaxed">
        <p>
          GuocoLand is a premier regional property company with operations in
          Singapore, China, Malaysia, and Vietnam. Listed on the Singapore
          Exchange, the company is known for developing iconic residences that
          redefine urban living.
        </p>

        <p>
          With a proven track record of delivering exceptional quality and
          innovative designs, GuocoLand has established itself as a trusted
          name in luxury property development across Asia.
        </p>
      </div>

      <!-- NOTABLE PROJECTS -->
      <div class="mt-12">
        <p class="text-xs tracking-[0.2em] uppercase text-gray-500 mb-4">
          Notable Projects
        </p>

        <div class="flex flex-wrap gap-3">
          <span
            v-for="p in projects"
            :key="p"
            class="border border-gray-300 bg-white px-4 py-2 text-sm"
          >
            {{ p }}
          </span>
        </div>
      </div>
    </div>

    <!-- RIGHT STATS -->
    <div class="grid grid-cols-1 sm:grid-cols-2 gap-8">

      <div class="bg-white border border-gray-200 p-10 text-center">
        <Building2 class="w-6 h-6 text-amber-600 mx-auto mb-4" />
        <p class="text-4xl font-serif text-gray-900 mb-2">20+</p>
        <p class="text-sm text-gray-500 tracking-wide">
          Premium Developments
        </p>
      </div>

      <div class="bg-white border border-gray-200 p-10 text-center">
        <Award class="w-6 h-6 text-amber-600 mx-auto mb-4" />
        <p class="text-4xl font-serif text-gray-900 mb-2">50+</p>
        <p class="text-sm text-gray-500 tracking-wide">
          Industry Awards
        </p>
      </div>

      <div class="bg-white border border-gray-200 p-10 text-center">
        <Globe class="w-6 h-6 text-amber-600 mx-auto mb-4" />
        <p class="text-4xl font-serif text-gray-900 mb-2">5</p>
        <p class="text-sm text-gray-500 tracking-wide">
          Countries
        </p>
      </div>

      <div class="bg-white border border-gray-200 p-10 text-center">
        <TrendingUp class="w-6 h-6 text-amber-600 mx-auto mb-4" />
        <p class="text-4xl font-serif text-gray-900 mb-2">45+</p>
        <p class="text-sm text-gray-500 tracking-wide">
          Years of Excellence
        </p>
      </div>

    </div>
  </div>
</section>

<!-- UNIT MIX -->
<section id="unit-mix" class="py-24 bg-[#faf9f7]">
  <div class="max-w-7xl mx-auto px-6">

    <!-- HEADER -->
    <div class="text-center mb-16">
      <p class="text-xs tracking-[0.25em] uppercase text-amber-600 mb-4">
        Unit Mix
      </p>
      <h2 class="text-4xl md:text-5xl font-serif text-gray-900 mb-6">
        Unit Distribution
      </h2>
      <div class="w-16 h-px bg-amber-400 mx-auto"></div>
    </div>

    <!-- TABLE -->
    <div class="overflow-x-auto">
      <table class="w-full border border-gray-200 bg-white/70">
        <thead>
          <tr class="bg-[#f3efe8] text-gray-700 text-sm tracking-widest uppercase">
            <th class="px-6 py-4 text-left border-b">Unit Type</th>
            <th class="px-6 py-4 text-left border-b">Size Range (sqft)</th>
            <th class="px-6 py-4 text-left border-b">Unit Mix</th>
          </tr>
        </thead>
        <tbody class="text-gray-800">
          <tr class="border-b">
            <td class="px-6 py-5 font-serif">
              2 Bedroom (1 Bath & 2 Bath)
            </td>
            <td class="px-6 py-5">
              540 sqft<br/>640 – 690 sqft
            </td>
            <td class="px-6 py-5">
              39%
            </td>
          </tr>

          <tr class="border-b bg-white/40">
            <td class="px-6 py-5 font-serif">
              3 Bedroom
            </td>
            <td class="px-6 py-5">
              900 sqft<br/>1,100 sqft
            </td>
            <td class="px-6 py-5">
              46%
            </td>
          </tr>

          <tr>
            <td class="px-6 py-5 font-serif">
              4 Bedroom with Private Lift
            </td>
            <td class="px-6 py-5">
              1,450 sqft<br/>1,800 sqft
            </td>
            <td class="px-6 py-5">
              15%
            </td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>
</section>


    <!-- LOCATION --> 
    <section id="location" class="py-24 bg-[#f6f2ea]">
  <div class="max-w-7xl mx-auto px-6">

    <!-- HEADER -->
    <div class="text-center max-w-3xl mx-auto mb-16">
      <p class="text-xs tracking-[0.25em] uppercase text-amber-600 mb-4">
        Prime Location
      </p>

      <h2 class="text-4xl md:text-5xl font-serif text-gray-900 mb-6">
        Location & Connectivity
      </h2>

      <div class="w-16 h-px bg-amber-400 mx-auto mb-8"></div>

      <p class="text-gray-600 leading-relaxed">
        Nestled in the heart of River Valley, River Modern offers unparalleled
        convenience with immediate access to Great World MRT and Singapore's
        most coveted lifestyle destinations.
      </p>
    </div>

    <!-- CONNECTIVITY CARDS (SIMPLIFIED) -->
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">

      <div class="bg-white/40 p-10 text-center">
        <div class="w-14 h-14 mx-auto mb-6 rounded-full bg-[#f3efe8] flex items-center justify-center">
          <Train class="w-6 h-6 text-amber-600" />
        </div>
        <p class="font-serif text-lg mb-2">
          Great World MRT
        </p>
        <p class="text-sm text-gray-600 mb-4">
          Direct access to Thomson-East Coast Line
        </p>
        <span class="inline-block bg-[#f3efe8] text-amber-700 text-xs tracking-widest px-4 py-1">
          1-MIN WALK
        </span>
      </div>

      <div class="bg-white/40 p-10 text-center">
        <div class="w-14 h-14 mx-auto mb-6 rounded-full bg-[#f3efe8] flex items-center justify-center">
          <ShoppingBag class="w-6 h-6 text-amber-600" />
        </div>
        <p class="font-serif text-lg mb-2">
          Orchard Road
        </p>
        <p class="text-sm text-gray-600 mb-4">
          Singapore's premier shopping belt
        </p>
        <span class="inline-block bg-[#f3efe8] text-amber-700 text-xs tracking-widest px-4 py-1">
          5-MIN DRIVE
        </span>
      </div>

      <div class="bg-white/40 p-10 text-center">
        <div class="w-14 h-14 mx-auto mb-6 rounded-full bg-[#f3efe8] flex items-center justify-center">
          <Briefcase class="w-6 h-6 text-amber-600" />
        </div>
        <p class="font-serif text-lg mb-2">
          CBD & Marina Bay
        </p>
        <p class="text-sm text-gray-600 mb-4">
          Singapore's financial hub
        </p>
        <span class="inline-block bg-[#f3efe8] text-amber-700 text-xs tracking-widest px-4 py-1">
          8-MIN DRIVE
        </span>
      </div>

      <div class="bg-white/40 p-10 text-center">
        <div class="w-14 h-14 mx-auto mb-6 rounded-full bg-[#f3efe8] flex items-center justify-center">
          <Clock class="w-6 h-6 text-amber-600" />
        </div>
        <p class="font-serif text-lg mb-2">
          Changi Airport
        </p>
        <p class="text-sm text-gray-600 mb-4">
          International connectivity
        </p>
        <span class="inline-block bg-[#f3efe8] text-amber-700 text-xs tracking-widest px-4 py-1">
          20-MIN DRIVE
        </span>
      </div>

    </div>
  </div>
</section>


<!-- LOCATION INSIGHT + MAP -->
<section class="py-24 bg-[#faf9f7]">
  <div class="max-w-7xl mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">

    <!-- LEFT: LOCATION INSIGHT -->
    <div>
      <p class="text-xs tracking-[0.25em] uppercase text-amber-600 mb-4">
        Location Insight
      </p>

      <h2 class="text-4xl md:text-5xl font-serif text-gray-900 mb-6">
        At The Centre Of It All
      </h2>

      <div class="w-16 h-px bg-amber-400 mb-8"></div>

      <div class="space-y-6 text-gray-700 leading-relaxed">

        <p>
          River Modern sits at the heart of District 9, surrounded by key growth
          precincts and ongoing rejuvenation from Kim Seng to Outram. With upcoming
          MRT lines strengthening island-wide connectivity and Robertson Quay
          maturing into a vibrant lifestyle enclave, the area continues to evolve
          while retaining its long-term value appeal.
        </p>

        <p>
          Direct access to Great World MRT connects River Modern effortlessly to
          the CBD, town and beyond, enhancing accessibility and long-term
          desirability within the Robertson Quay precinct.
        </p>

        <p>
          Minutes to Orchard Road, CBD, Civic District and Marina Bay, River Modern
          offers everyday convenience — saving time, enhancing lifestyle and
          supporting long-term value.
        </p>

        <p>
          The CBD serves as Singapore’s financial heart, anchored by icons
          including GuocoLand’s landmark Tanjong Pagar Centre, while Orchard Road
          and Marina Bay complete the city lifestyle experience.
        </p>

      </div>
    </div>

    <!-- RIGHT: MAP -->
    <div class="w-full h-[500px] overflow-hidden">
      <iframe
        class="w-full h-full"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.801708072332!2d103.83270137485464!3d1.2934449986942722!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da198a619618e1%3A0xb6f7764f35753ea7!2sRiver%20Modern!5e0!3m2!1sen!2ssg!4v1766071194629!5m2!1sen!2ssg"
        loading="lazy"
        style="border:0"
        allowfullscreen
      ></iframe>
    </div>

  </div>
</section>

<!-- LOCATION INSIGHTS -->
<section class="py-24 bg-[#f6f2ea]">
  <div class="max-w-7xl mx-auto px-6">

    <!-- HEADER -->
    <div class="text-center max-w-3xl mx-auto mb-16">
      <p class="text-xs tracking-[0.25em] uppercase text-amber-600 mb-4">
        Location Insights
      </p>
      <h2 class="text-4xl md:text-5xl font-serif text-gray-900 mb-6">
        A District That Continues To Grow
      </h2>
      <div class="w-16 h-px bg-amber-400 mx-auto"></div>
    </div>

    <!-- TOP: GROWTH / CONNECTIVITY / LIFESTYLE -->
    <div class="grid grid-cols-1 md:grid-cols-3 gap-10 mb-20">

      <div class="bg-white/70 border border-gray-200 p-8">
        <h3 class="font-serif text-xl mb-4 text-gray-900">
          New Growth, New Potential
        </h3>
        <p class="text-gray-700 leading-relaxed">
          River Modern sits at the heart of District 9, surrounded by key growth
          precincts and ongoing rejuvenation from Kim Seng to Outram. With upcoming
          MRT lines strengthening island-wide connectivity and Robertson Quay
          maturing into a vibrant lifestyle enclave, the area continues to evolve
          while retaining strong long-term value appeal.
        </p>
      </div>

      <div class="bg-white/70 border border-gray-200 p-8">
        <h3 class="font-serif text-xl mb-4 text-gray-900">
          Boosted Connectivity
        </h3>
        <p class="text-gray-700 leading-relaxed">
          Direct access to Great World MRT connects River Modern effortlessly to
          the CBD, Orchard and beyond. This enhanced accessibility strengthens
          long-term desirability within the Robertson Quay precinct, making daily
          commuting and city living seamless.
        </p>
      </div>

      <div class="bg-white/70 border border-gray-200 p-8">
        <h3 class="font-serif text-xl mb-4 text-gray-900">
          Singapore River Lifestyle Corridor
        </h3>
        <p class="text-gray-700 leading-relaxed">
          Boat Quay, Clarke Quay and Robertson Quay form Singapore’s iconic
          riverfront corridor — a refined mix of dining, culture and leisure.
          As the closest quay to River Modern, Robertson Quay offers a calm yet
          cosmopolitan living environment by the river.
        </p>
      </div>

    </div>

   

  </div>
</section>



  <section class="py-24 bg-[#faf9f7]">
    <!-- <div class="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-16 items-start"> -->
      <div class="text-center max-w-3xl mx-auto mb-20">
        <div class="text-center max-w-3xl mx-auto mb-20">
          <p class="text-xs tracking-[0.25em] uppercase text-amber-600 mb-4">
            Transport
          </p>

          <h2 class="text-4xl md:text-5xl font-serif text-gray-900 mb-6">
            Transport Connectivity
          </h2>

          <div class="w-16 h-px bg-amber-400 mx-auto mb-8"></div>

          <p class="text-gray-600 leading-relaxed">
            Well-connected by an established transport network, River Modern is located
            near multiple MRT stations and bus stops, ensuring seamless travel across
            the city for work, leisure and everyday living.
          </p>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-10">

          <div
            v-for="section in locationConnectivity"
            :key="section.title"
            class="border border-gray-200 bg-white/60 p-8"
          >
            <!-- SECTION TITLE -->
            <h3 class="font-serif text-2xl mb-6 text-gray-900">
              {{ section.title }}
            </h3>

            <!-- LIST -->
            <ul class="space-y-4">
              <li
                v-for="item in section.items"
                :key="item.name"
                class="flex items-center justify-between border-b border-gray-200 pb-3"
              >
                <span class="text-gray-700">
                  {{ item.name }}
                </span>

                <span class="text-xs tracking-widest bg-[#f3efe8] text-amber-700 px-3 py-1 whitespace-nowrap">
                  {{ item.distance }}
                </span>
              </li>
            </ul>
          </div>

        </div>


      </div>

  </section> 

    <!-- CONTACT -->
    <section id="contact" class="py-24 bg-slate-900 text-white">
      <div class="max-w-3xl mx-auto px-6 text-center">

        <p class="text-xs tracking-[0.25em] uppercase text-amber-400 mb-4">
          Get In Touch
        </p>

        <h2 class="text-4xl md:text-5xl font-serif mb-6">
          Request Full Details & Price List
        </h2>

        <p class="text-gray-300 mb-12 leading-relaxed">
          Speak directly with our sales consultant to receive the full brochure,
          floor plans, pricing information and latest availability.
        </p>

        <!-- WHATSAPP CTA -->
        <a
          :href="whatsappUrl"
          target="_blank"
          class="
            inline-flex items-center justify-center gap-3
            border border-white px-10 py-4
            text-white tracking-widest
            transition-all duration-300 ease-out
            hover:bg-white hover:!text-black
            hover:-translate-y-0.5 hover:shadow-lg
          "
        >
          <span>Contact via WhatsApp</span>
        </a>

        <p class="text-xs text-gray-400 mt-6">
          Instant response<br/>
          By starting this conversation, you consent to the collection and use of your contact details to provide project information and future updates. You may opt out at any time.
        </p>

      </div>
    </section>


    <!-- FOOTER -->
    <footer class="bg-[#0f3a4a] text-white">
  <div class="max-w-4xl mx-auto px-6 py-16 space-y-8">

    <!-- AGENCY INFO -->
    <div class="bg-white/5 rounded-xl p-6 space-y-4">
      <p class="uppercase tracking-widest text-sm text-gray-300">
        Appointed Marketing Agency:
      </p>
      <img src="@/assets/propnex_logo.png" style="height:auto;width:20%;">
      <p class="text-xl font-semibold">
        {{ footer.agency }}
      </p>

      <p class="text-sm text-gray-300 leading-relaxed">
        Agent Name: {{ footer.agentName }}<br />
        CEA Reg No: {{ footer.agentReg }}<br />
        Contact No: {{ footer.agentPhone }}
      </p>
    </div>

    <!-- DISCLAIMER -->
    <div class="text-xs text-gray-300 leading-relaxed space-y-4">
      <p>
        <strong>Disclaimer:</strong><br />
        {{ footer.disclaimer }}
      </p>

      <p>
        <strong>Legal Notice:</strong><br />
        {{ footer.legal }}
      </p>
    </div>

  </div>

  <!-- COPYRIGHT BAR -->
  <!-- <div class="bg-black text-center py-6 text-sm">
    © {{ year }} River Modern
  </div> -->
</footer>



    <!-- WHATSAPP -->
    <a
      :href="whatsappUrl"
      target="_blank"
      class="fixed bottom-6 right-6 bg-green-500 text-white w-14 h-14 flex items-center justify-center rounded-full"
    >
      <MessageCircle class="w-7 h-7 text-white" />
    </a>

  </main>
</template>

<script>
import heroImage from "@/assets/hero-building.jpg";
import {
  Building2,
  Landmark,
  MapPin,
  Home,
  FileText,
  TrendingUp,
  Globe,Award,
  Train,
  ShoppingBag,
  Briefcase,
  Clock,MessageCircle, 
  LandPlot,CircleParking,
  DoorOpen, Info
  
} from 'lucide-vue-next'

export default {
  components: {
    Building2,
    Landmark,
    MapPin,
    Home,
    FileText,
  TrendingUp,
  Globe,Award,
  Train,
  ShoppingBag,
  Briefcase,
  Clock,MessageCircle,
  LandPlot,CircleParking,
  DoorOpen, Info

  },
  data() {
    return {
       launch: {
      preview: "21 Feb 2026",
      booking: "7 Mar 2026"
    },
      heroImage,
      isScrolled: false,
      navLinks: [
        { label: "Overview", id: "overview" },
        { label: "Developer", id: "developer" },
        { label: "Location", id: "location" }
      ],
      projects: [
        "Martin Modern",
        "Wallich Residence",
        "Midtown Modern",
        "Lentor Modern"
      ],
      form: { name: "", email: "", phone: "" },
      submitting: false,
      footer: {
        agency: "PropNex Realty Pte Ltd",
        agentName: " Kyran Yeo",
        agentReg: "R073281I",
        agentPhone: "+65 8862 7292",
        disclaimer:
          "PropNex Realty Pte Ltd is the appointed marketing agency for River Modern by GuocoLand (Singapore) Pte Ltd. This is not the official developer site. All information provided is for general information purposes only. Buyers pay no commission; any fees are paid directly by the developer.",
        legal:
          "This site may contain forward-looking statements involving risks, uncertainties and assumptions. While we strive for accuracy, neither the developer nor its agents accept liability for any errors or omissions. To the fullest extent permitted by law, information and visuals are not contractual representations. Renderings, illustrations and photos are artistic impressions and may differ from the final product."
      },
      locationConnectivity: [
  {
    title: "Trains",
    items: [
      { name: "Great World MRT", distance: "180m" },
      { name: "Havelock MRT", distance: "610m" },
      { name: "Somerset MRT", distance: "840m" }
    ]
  },
  {
    title: "Bus Stops",
    items: [
      { name: "Opp St. Thomas Wk", distance: "240m" },
      { name: "St. Thomas Wk", distance: "270m" },
      { name: "Opp Great World City", distance: "270m" }
    ],
   

  },
  
]

    };
  },
  computed: {
    whatsappUrl() {
      return "https://wa.me/6588627292?text=Hi%20I%20am%20interested%20in%20River%20Modern";
    }
  },
  mounted() {
    window.addEventListener("scroll", () => {
      this.isScrolled = window.scrollY > 50;
    });
  },
  methods: {
    scrollTo(id) {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    },
    async submit() {
      this.submitting = true;
      await new Promise(r => setTimeout(r, 1000));
      alert("Thanks! Agent will contact you.");
      this.form = { name: "", email: "", phone: "" };
      this.submitting = false;
    }
  }
};
</script>
